import { bindActionCreators } from "redux";
import { call, put, select, take } from "redux-saga/effects";

import * as apiCaller from "./../api/apiCaller";
import { globalHistory } from "./../history";
import AppError from "./../ultis/AppError";
export const GET_LIST_CAMPAIGNS = "GET_LIST_CAMPAIGNS";
export const GET_LIST_CAMPAIGNS_ERROR = "GET_LIST_CAMPAIGNS_ERROR";
export const GET_LIST_CAMPAIGNS_SUCCESS = "GET_LIST_CAMPAIGNS_SUCCESS";

export const GET_ALL_CAMPAIGNS = "GET_ALL_CAMPAIGNS";
export const GET_ALL_CAMPAIGNS_ERROR = "GET_ALL_CAMPAIGNS_ERROR";
export const GET_ALL_CAMPAIGNS_SUCCESS = "GET_ALL_CAMPAIGNS_SUCCESS";

export const GET_LIST_CAMPAIGNS_GROUP = "GET_LIST_CAMPAIGNS_GROUP";
export const GET_LIST_CAMPAIGNS_GROUP_SUCCESS =
  "GET_LIST_CAMPAIGNS_GROUP_SUCCESS";
export const GET_LIST_CAMPAIGNS_GROUP_ERROR = "GET_LIST_CAMPAIGNS_GROUP_ERROR";

export const COUNT_LIST_CAMPAIGNS_GROUP = "COUNT_LIST_CAMPAIGNS_GROUP";
export const COUNT_LIST_CAMPAIGNS_GROUP_SUCCESS =
  "COUNT_LIST_CAMPAIGNS_GROUP_SUCCESS";
export const COUNT_LIST_CAMPAIGNS_GROUP_ERROR =
  "COUNT_LIST_CAMPAIGNS_GROUP_ERROR";

export const COUNT_LIST_CAMPAIGNS = "COUNT_LIST_CAMPAIGNS";
export const COUNT_LIST_CAMPAIGNS_ERROR = "COUNT_LIST_CAMPAIGNS_ERROR";
export const COUNT_LIST_CAMPAIGNS_SUCCESS = "COUNT_LIST_CAMPAIGNS_SUCCESS";

export const ADD_NEW_CAMPAIGN = "ADD_NEW_CAMPAIGN";
export const ADD_NEW_CAMPAIGN_SUCCESS = "ADD_NEW_CAMPAIGN_SUCCESS";
export const ADD_NEW_CAMPAIGN_ERROR = "ADD_NEW_CAMPAIGN_ERROR";

export const ADD_NEW_CAMPAIGN_GROUP = "ADD_NEW_CAMPAIGN_GROUP";
export const ADD_NEW_CAMPAIGN_GROUP_SUCCESS = "ADD_NEW_CAMPAIGN_GROUP_SUCCESS";
export const ADD_NEW_CAMPAIGN_GROUP_ERROR = "ADD_NEW_CAMPAIGN_GROUP_ERROR";

export const EDIT_A_CAMPAIGN = "EDIT_A_CAMPAIGN";
export const EDIT_A_CAMPAIGN_SUCCESS = "EDIT_A_CAMPAIGN_SUCCESS";
export const EDIT_A_CAMPAIGN_ERROR = "EDIT_A_CAMPAIGN_ERROR";

export const EDIT_A_CAMPAIGN_GROUP = "EDIT_A_CAMPAIGN_GROUP";
export const EDIT_A_CAMPAIGN_GROUP_SUCCESS = "EDIT_A_CAMPAIGN_GROUP_SUCCESS";
export const EDIT_A_CAMPAIGN_GROUP_ERROR = "EDIT_A_CAMPAIGN_GROUP_ERROR";

export const RELOAD_CAMPAIGN = "RELOAD_CAMPAIGN";
export const RELOAD_CAMPAIGN_SUCCESS = "RELOAD_CAMPAIGN_SUCCESS";
export const RELOAD_CAMPAIGN_ERROR = "RELOAD_CAMPAIGN_ERROR";

export const DELETE_A_CAMPAIGN = "DELETE_A_CAMPAIGN";
export const DELETE_A_CAMPAIGN_SUCCESS = "DELETE_A_CAMPAIGN_SUCCESS";
export const DELETE_A_CAMPAIGN_ERROR = "DELETE_A_CAMPAIGN_ERROR";

export const DELETE_A_CAMPAIGN_GROUP = "DELETE_A_CAMPAIGN_GROUP";
export const DELETE_A_CAMPAIGN_GROUP_SUCCESS =
  "DELETE_A_CAMPAIGN_GROUP_SUCCESS";
export const DELETE_A_CAMPAIGN_GROUP_ERROR = "DELETE_A_CAMPAIGN_GROUP_ERROR";

export const GET_A_CAMPAIGN_DETAIL = "GET_A_CAMPAIGN_DETAIL";
export const GET_A_CAMPAIGN_DETAIL_SUCCESS = "GET_A_CAMPAIGN_DETAIL_SUCCESS";
export const GET_A_CAMPAIGN_DETAIL_ERROR = "GET_A_CAMPAIGN_DETAIL_ERROR";

export const CONFIG_CAMPAIGN = "CONFIG_CAMPAIGN";
export const CONFIG_CAMPAIGN_SUCCESS = "CONFIG_CAMPAIGN_SUCCESS";
export const CONFIG_CAMPAIGN_ERROR = "CONFIG_CAMPAIGN_ERROR";

export const CAMPAIGN_CONFIG = "CAMPAIGN_CONFIG";
export const CAMPAIGN_CONFIG_SUCCESS = "CAMPAIGN_CONFIG_SUCCESS";
export const CAMPAIGN_CONFIG_ERROR = "CAMPAIGN_CONFIG_ERROR";

export const GET_CAMPAIGN_ALLOCATION = "GET_CAMPAIGN_ALLOCATION";
export const GET_CAMPAIGN_ALLOCATION_SUCCESS =
  "GET_CAMPAIGN_ALLOCATION_SUCCESS";
export const GET_CAMPAIGN_ALLOCATION_ERROR = "GET_CAMPAIGN_ALLOCATION_ERROR";

export const COUNT_LIST_CAMPAIGNS_ALLOCATION =
  "COUNT_LIST_CAMPAIGNS_ALLOCATION";
export const COUNT_LIST_CAMPAIGNS_ALLOCATION_SUCCESS =
  "COUNT_LIST_CAMPAIGNS_ALLOCATION_SUCCESS";
export const COUNT_LIST_CAMPAIGNS_ALLOCATION_ERROR =
  "COUNT_LIST_CAMPAIGNS_ALLOCATION_ERROR";

export const OPEN_MODAL_NOTIFI = "OPEN_MODAL_NOTIFI";
export const CLOSE_MODAL_CAMPAIGN = "CLOSE_MODAL_CAMPAIGN";

export const CAMPAIGN_ALLOCATION_GET_MORE_DATA =
  "CAMPAIGN_ALLOCATION_GET_MORE_DATA";
export const CAMPAIGN_ALLOCATION_GET_MORE_DATA_SUCCESS =
  "CAMPAIGN_ALLOCATION_GET_MORE_DATA_SUCCESS";
export const CAMPAIGN_ALLOCATION_GET_MORE_DATA_ERROR =
  "CAMPAIGN_ALLOCATION_GET_MORE_DATA_ERROR";

export const GET_REASON_SELECT_LIST = "GET_REASON_SELECT_LIST";
export const GET_REASON_SELECT_LIST_SUCCESS = "GET_REASON_SELECT_LIST_SUCCESS";
export const GET_REASON_SELECT_LIST_ERROR = "GET_REASON_SELECT_LIST_ERROR";

export const GET_LIST_CAMPAIGNS_SERVICE = "GET_LIST_CAMPAIGNS_SERVICE";
export const GET_LIST_CAMPAIGNS_SERVICE_SUCCESS =
  "GET_LIST_CAMPAIGNS_SERVICE_SUCCESS";
export const GET_LIST_CAMPAIGNS_SERVICE_ERROR =
  "GET_LIST_CAMPAIGNS_SERVICE_ERROR";

export const COUNT_LIST_CAMPAIGNS_SERVICE = "COUNT_LIST_CAMPAIGNS_SERVICE";
export const COUNT_LIST_CAMPAIGNS_SERVICE_SUCCESS =
  "COUNT_LIST_CAMPAIGNS_SERVICE_SUCCESS";
export const COUNT_LIST_CAMPAIGNS_SERVICE_ERROR =
  "COUNT_LIST_CAMPAIGNS_SERVICE_ERROR";

export const ADD_NEW_CAMPAIGN_SERVICE = "ADD_NEW_CAMPAIGN_SERVICE";
export const ADD_NEW_CAMPAIGN_SERVICE_SUCCESS =
  "ADD_NEW_CAMPAIGN_SERVICE_SUCCESS";
export const ADD_NEW_CAMPAIGN_SERVICE_ERROR = "ADD_NEW_CAMPAIGN_SERVICE_ERROR";

export const EDIT_A_CAMPAIGN_SERVICE = "EDIT_A_CAMPAIGN_SERVICE";
export const EDIT_A_CAMPAIGN_SERVICE_SUCCESS =
  "EDIT_A_CAMPAIGN_SERVICE_SUCCESS";
export const EDIT_A_CAMPAIGN_SERVICE_ERROR = "EDIT_A_CAMPAIGN_SERVICE_ERROR";

export const DELETE_A_CAMPAIGN_SERVICE = "DELETE_A_CAMPAIGN_SERVICE";
export const DELETE_A_CAMPAIGN_SERVICE_SUCCESS =
  "DELETE_A_CAMPAIGN_SERVICE_SUCCESS";
export const DELETE_A_CAMPAIGN_SERVICE_ERROR =
  "DELETE_A_CAMPAIGN_SERVICE_ERROR";

export const CHECK_CAMPAIGN_GROUP_CODE = "CHECK_CAMPAIGN_GROUP_CODE";
export const CHECK_CAMPAIGN_GROUP_CODE_SUCCESS =
  "CHECK_CAMPAIGN_GROUP_CODE_SUCCESS";
export const CHECK_CAMPAIGN_GROUP_CODE_ERROR =
  "CHECK_CAMPAIGN_GROUP_CODE_ERROR";

export const CHECK_CAMPAIGN_SERVICE_CODE = "CHECK_CAMPAIGN_SERVICE_CODE";
export const CHECK_CAMPAIGN_SERVICE_CODE_SUCCESS =
  "CHECK_CAMPAIGN_SERVICE_CODE_SUCCESS";
export const CHECK_CAMPAIGN_SERVICE_CODE_ERROR =
  "CHECK_CAMPAIGN_SERVICE_CODE_ERROR";

/**
 * Reducer
 */

const initialState = {
  campaigns: [],
  campaign: {},
  error: false,
  count: 0,
  loading: false,
  campaignAllocation: [],
  newCampaign: undefined,
  openModal: false,
  closeDialog: true,
  getMoreData: {},
  dataCampaignEdit: null,
  reasonSelectList: [],
  reload: {},
  campaignsGroup: [],
  loadingGroup: false,
  countGroup: 0,
  campaignGroupDetail: null,

  campaignsService: [],
  loadingService: false,
  countService: 0,
  campaignServiceDetail: null,
  allCampaign: [],
  checkCode: null,
  checkCodeService: null,
};

export const campaignsReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_CAMPAIGNS:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        loading: false,
        campaigns: action.payload,
      };
    case GET_LIST_CAMPAIGNS_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    case CHECK_CAMPAIGN_GROUP_CODE:
      return {
        ...state,
        loading: true,
      };
    case CHECK_CAMPAIGN_GROUP_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        checkCode: action.payload,
      };
    case CHECK_CAMPAIGN_GROUP_CODE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    case CHECK_CAMPAIGN_SERVICE_CODE:
      return {
        ...state,
        loading: true,
      };
    case CHECK_CAMPAIGN_SERVICE_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        checkCodeService: action.payload,
      };
    case CHECK_CAMPAIGN_SERVICE_CODE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    case GET_ALL_CAMPAIGNS:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        loading: false,
        allCampaign: action.payload,
      };
    case GET_ALL_CAMPAIGNS_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //count list
    case COUNT_LIST_CAMPAIGNS:
      return {
        ...state,
      };
    case COUNT_LIST_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        count: action.payload.count,
      };
    case COUNT_LIST_CAMPAIGNS_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //add new
    case ADD_NEW_CAMPAIGN:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        campaign: action.payload,
      };
    case ADD_NEW_CAMPAIGN_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    //edit
    case EDIT_A_CAMPAIGN:
      return {
        ...state,
        loading: false,
      };
    case EDIT_A_CAMPAIGN_SUCCESS: {
      let stateCampaigns = { ...state.campaigns };
      for (const key in stateCampaigns) {
        if (stateCampaigns[key].id === action.payload.id) {
          stateCampaigns[key] = { ...stateCampaigns[key], ...action.payload };
        }
      }

      return {
        ...state,
        loading: false,
        campaigns: stateCampaigns,
      };
    }
    case EDIT_A_CAMPAIGN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    ///delete
    case DELETE_A_CAMPAIGN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_A_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        campaign: action.payload,
      };
    case DELETE_A_CAMPAIGN_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    //get item
    case GET_A_CAMPAIGN_DETAIL:
      return {
        ...state,
        loading: true,
      };
    case GET_A_CAMPAIGN_DETAIL_SUCCESS:
      return {
        ...state,
        campaign: action.payload,
      };
    case GET_A_CAMPAIGN_DETAIL_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //config
    case CAMPAIGN_CONFIG:
      return {
        ...state,
        loading: true,
        openModal: false,
        closeDialog: false,
      };
    case CAMPAIGN_CONFIG_SUCCESS:
      return {
        ...state,
        newCampaign: action.payload,
        closeDialog: false,
        openModal: true,
      };
    case CAMPAIGN_CONFIG_ERROR:
      return {
        ...state,
        error: action.error,
        openModal: false,
        closeDialog: false,
      };
    //get
    case GET_CAMPAIGN_ALLOCATION:
      return {
        ...state,
        loading: true,
      };
    case GET_CAMPAIGN_ALLOCATION_SUCCESS:
      return {
        ...state,
        campaignAllocation: action.payload,
      };
    case GET_CAMPAIGN_ALLOCATION_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case COUNT_LIST_CAMPAIGNS_ALLOCATION:
      return {
        ...state,
      };
    case COUNT_LIST_CAMPAIGNS_ALLOCATION_SUCCESS:
      return {
        ...state,
        countCampaignAllocation: action.payload.count,
      };
    case COUNT_LIST_CAMPAIGNS_ALLOCATION_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case GET_REASON_SELECT_LIST:
      return {
        ...state,
        reasonSelectList: [],
      };
    case GET_REASON_SELECT_LIST_SUCCESS:
      return {
        ...state,
        reasonSelectList: action.payload,
      };
    case GET_REASON_SELECT_LIST_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //modal
    case OPEN_MODAL_NOTIFI:
      return {
        ...state,
        openModal: false,
      };
    case CLOSE_MODAL_CAMPAIGN:
      return {
        ...state,
        closeDialog: true,
      };
    //get more data
    case CAMPAIGN_ALLOCATION_GET_MORE_DATA:
      return {
        ...state,
        loading: true,
        openModal: false,
      };
    case CAMPAIGN_ALLOCATION_GET_MORE_DATA_SUCCESS:
      return {
        ...state,
        getMoreData: action.payload,
        openModal: true,
      };
    case CAMPAIGN_ALLOCATION_GET_MORE_DATA_ERROR:
      return {
        ...state,
        error: action.error,
        openModal: false,
      };
    //get more data
    case RELOAD_CAMPAIGN:
      return {
        ...state,
      };
    case RELOAD_CAMPAIGN_SUCCESS:
      return {
        ...state,
        reload: action.payload,
      };
    case RELOAD_CAMPAIGN_ERROR:
      return {
        ...state,
        error: action.error,
      };
    // campaign group
    case GET_LIST_CAMPAIGNS_GROUP:
      return {
        ...state,
        loadingGroup: true,
      };
    case GET_LIST_CAMPAIGNS_GROUP_SUCCESS:
      return {
        ...state,
        loadingGroup: false,
        campaignsGroup: action.payload,
      };
    case GET_LIST_CAMPAIGNS_GROUP_ERROR:
      return {
        ...state,
        loadingGroup: false,
        campaignsGroup: [],
        error: action.error,
      };
    // count campaign group
    case COUNT_LIST_CAMPAIGNS_GROUP:
      return {
        ...state,
      };
    case COUNT_LIST_CAMPAIGNS_GROUP_SUCCESS:
      return {
        ...state,
        countGroup: action.payload.count,
      };
    case COUNT_LIST_CAMPAIGNS_GROUP_ERROR:
      return {
        ...state,
        error: action.error,
      };
    // add new campaign group
    case ADD_NEW_CAMPAIGN_GROUP:
      return {
        ...state,
        loadingGroup: true,
      };
    case ADD_NEW_CAMPAIGN_GROUP_SUCCESS:
      return {
        ...state,
        loadingGroup: false,
        campaignGroupDetail: action.payload,
      };
    case ADD_NEW_CAMPAIGN_GROUP_ERROR:
      return {
        ...state,
        loadingGroup: true,
        error: action.error,
        campaignGroupDetail: null,
      };
    // edit campaign group
    case EDIT_A_CAMPAIGN_GROUP:
      return {
        ...state,
        loadingGroup: true,
      };
    case EDIT_A_CAMPAIGN_GROUP_SUCCESS: {
      const campaignGroupDetail = state.campaignsGroup.filter(
        (i) => i.id !== action.data.id
      );
      return {
        ...state,
        loadingGroup: false,
        // campaignGroupDetail,
      };
    }
    case EDIT_A_CAMPAIGN_GROUP_ERROR:
      return {
        ...state,
        loadingGroup: false,
        error: action.error,
      };
    ///delete campaign group
    case DELETE_A_CAMPAIGN_GROUP:
      return {
        ...state,
        loadingGroup: true,
      };
    case DELETE_A_CAMPAIGN_GROUP_SUCCESS:
      return {
        ...state,
        loadingGroup: false,
        campaignsGroup: action.payload,
      };
    case DELETE_A_CAMPAIGN_GROUP_ERROR:
      return {
        ...state,
        loadingGroup: true,
        error: action.error,
      };
    //    ###################
    // campaign service
    case GET_LIST_CAMPAIGNS_SERVICE:
      return {
        ...state,
        loadingService: true,
      };
    case GET_LIST_CAMPAIGNS_SERVICE_SUCCESS:
      return {
        ...state,
        loadingService: false,
        campaignsService: action.payload,
      };
    case GET_LIST_CAMPAIGNS_SERVICE_ERROR:
      return {
        ...state,
        loadingService: false,
        campaignsService: [],
        error: action.error,
      };
    // count campaign service
    case COUNT_LIST_CAMPAIGNS_SERVICE:
      return {
        ...state,
      };
    case COUNT_LIST_CAMPAIGNS_SERVICE_SUCCESS:
      return {
        ...state,
        countService: action.payload.count,
      };
    case COUNT_LIST_CAMPAIGNS_SERVICE_ERROR:
      return {
        ...state,
        error: action.error,
      };
    // add new campaign service
    case ADD_NEW_CAMPAIGN_SERVICE:
      return {
        ...state,
        loadingService: true,
      };
    case ADD_NEW_CAMPAIGN_SERVICE_SUCCESS:
      return {
        ...state,
        loadingService: false,
        campaignServiceDetail: action.payload,
      };
    case ADD_NEW_CAMPAIGN_SERVICE_ERROR:
      return {
        ...state,
        loadingService: true,
        error: action.error,
        campaignServiceDetail: null,
      };
    // edit campaign service
    case EDIT_A_CAMPAIGN_SERVICE:
      return {
        ...state,
        loadingService: true,
      };
    case EDIT_A_CAMPAIGN_SERVICE_SUCCESS: {
      const campaignGroupDetail = state.campaignsGroup.filter(
        (i) => i.id !== action.data.id
      );
      return {
        ...state,
        loadingService: false,
        // campaignGroupDetail,
      };
    }
    case EDIT_A_CAMPAIGN_SERVICE_ERROR:
      return {
        ...state,
        loadingService: false,
        error: action.error,
      };
    ///delete campaign service
    case DELETE_A_CAMPAIGN_SERVICE:
      return {
        ...state,
        loadingService: true,
      };
    case DELETE_A_CAMPAIGN_SERVICE_SUCCESS:
      return {
        ...state,
        loadingService: false,
        campaignsService: action.payload,
      };
    case DELETE_A_CAMPAIGN_SERVICE_ERROR:
      return {
        ...state,
        loadingService: true,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListCampaigns = (order, limit, skip, where) => ({
  type: GET_LIST_CAMPAIGNS,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const getAllCampaigns = () => ({
  type: GET_ALL_CAMPAIGNS,
});

export const countListCampaigns = (where) => ({
  type: COUNT_LIST_CAMPAIGNS,
  data: {
    where,
  },
});

export const addNewCampaign = (
  name,
  note,
  callsPerAgent,
  startAt,
  endAt,
  agents,
  campaignGroupId,
  campaignServiceId
) => ({
  type: ADD_NEW_CAMPAIGN,
  data: {
    name,
    note,
    callsPerAgent,
    startAt,
    endAt,
    agents,
    campaignGroupId,
    campaignServiceId,
  },
});

export const editCampaign = (
  id,
  isRunning,
  name,
  note,
  callsPerAgent,
  startAt,
  endAt,
  agents,
  campaignGroupId,
  campaignServiceId
) => ({
  type: EDIT_A_CAMPAIGN,
  data: {
    id,
    isRunning,
    name,
    note,
    callsPerAgent,
    startAt,
    endAt,
    agents,
    campaignGroupId,
    campaignServiceId,
  },
});

export const deleteCampaign = (id) => ({
  type: DELETE_A_CAMPAIGN,
  data: {
    id,
  },
});

export const getACampaignDetail = (id) => ({
  type: GET_A_CAMPAIGN_DETAIL,
  data: {
    id,
  },
});

export const getCampaignAllocation = (order, limit, skip, where) => ({
  type: GET_CAMPAIGN_ALLOCATION,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const countListCampaignsAllocation = (where) => ({
  type: COUNT_LIST_CAMPAIGNS_ALLOCATION,
  data: {
    where,
  },
});

export const campaignConfig = (
  campaignId,
  contactFileId,
  number,
  agentAllocationType,
  allowDuplicate,
  stages,
  formId,
  type,
  campaignIds,
  filterData,
  limit,
  agentId
) => ({
  type: CAMPAIGN_CONFIG,
  data: {
    campaignId,
    contactFileId,
    number,
    agentAllocationType,
    allowDuplicate,
    stages,
    formId,
    type,
    campaignIds,
    filterData,
    limit,
    agentId,
  },
});

export const openModalNotification = () => ({
  type: OPEN_MODAL_NOTIFI,
});

export const closeModalCampaign = () => ({
  type: CLOSE_MODAL_CAMPAIGN,
});

export const getMoreDataAction = (campaignAllocationId, limit) => ({
  type: CAMPAIGN_ALLOCATION_GET_MORE_DATA,
  data: {
    campaignAllocationId,
    limit,
  },
});

export const getReasonSelectList = () => ({
  type: GET_REASON_SELECT_LIST,
});

export const reloadCampaigns = (id, isDeleted) => ({
  type: RELOAD_CAMPAIGN,
  data: {
    id,
    isDeleted,
  },
});

export const getListCampaignsGroup = (order, limit, skip, where) => ({
  type: GET_LIST_CAMPAIGNS_GROUP,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const countListCampaignsGroup = (where) => ({
  type: COUNT_LIST_CAMPAIGNS_GROUP,
  data: {
    where,
  },
});

export const addNewCampaignGroup = (name, code) => ({
  type: ADD_NEW_CAMPAIGN_GROUP,
  data: {
    name,
    code,
  },
});

export const editCampaignGroup = (id, name, code) => ({
  type: EDIT_A_CAMPAIGN_GROUP,
  data: {
    id,
    name,
    code,
  },
});

export const deleteCampaignGroup = (id) => ({
  type: DELETE_A_CAMPAIGN_GROUP,
  data: {
    id,
  },
});

//

export const getListCampaignsService = (order, limit, skip, where) => ({
  type: GET_LIST_CAMPAIGNS_SERVICE,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const countListCampaignsService = (where) => ({
  type: COUNT_LIST_CAMPAIGNS_SERVICE,
  data: {
    where,
  },
});

export const addNewCampaignService = (name, code) => ({
  type: ADD_NEW_CAMPAIGN_SERVICE,
  data: {
    name,
    code,
  },
});

export const editCampaignService = (id, name, code) => ({
  type: EDIT_A_CAMPAIGN_SERVICE,
  data: {
    id,
    name,
    code,
  },
});

export const deleteCampaignService = (id) => ({
  type: DELETE_A_CAMPAIGN_SERVICE,
  data: {
    id,
  },
});

export const checkCampaignGroupCode = (code) => {
  return {
    type: CHECK_CAMPAIGN_GROUP_CODE,
    data: {
      code,
    },
  };
};

export const checkCampaignServiceCode = (code) => {
  return {
    type: CHECK_CAMPAIGN_SERVICE_CODE,
    data: {
      code,
    },
  };
};

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListCampaigns,
      checkCampaignGroupCode,
      checkCampaignServiceCode,
      getAllCampaigns,
      countListCampaigns,
      addNewCampaign,
      editCampaign,
      deleteCampaign,
      getACampaignDetail,
      campaignConfig,
      getCampaignAllocation,
      countListCampaignsAllocation,
      openModalNotification,
      closeModalCampaign,
      getMoreDataAction,
      getReasonSelectList,
      reloadCampaigns,
      getListCampaignsGroup,
      countListCampaignsGroup,
      addNewCampaignGroup,
      editCampaignGroup,
      deleteCampaignGroup,
      getListCampaignsService,
      countListCampaignsService,
      addNewCampaignService,
      editCampaignService,
      deleteCampaignService,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListCampaignsApi = (order, limit, skip, where) => {
  return apiCaller.getLogs(
    "/mini-crm/campaign",
    { order, limit, skip, ...where },
    { fastQuery: true }
  );
};
const checkCampaignGroupCodeApi = (code) => {
  return apiCaller.getLogs(
    "/mini-crm/campaign-group/checkCampaignGroupCode",
    null,
    { code: code }
  );
};
const checkCampaignServiceCodeApi = (code) => {
  return apiCaller.getLogs(
    "/mini-crm/campaign-service/checkCampaignServiceCode",
    null,
    { code: code }
  );
};
const getAllCampaignsApi = () => {
  return apiCaller.getLogs(
    "/mini-crm/campaign",
    { order: "createdAt DESC" },
    { query: "all", fastQuery: true }
  );
};
const countListCampaignsApi = (where) => {
  return apiCaller.getData("/mini-crm/campaign/count", { ...where });
};
const addNewCampaignsApi = (
  name,
  note,
  callsPerAgent,
  startAt,
  endAt,
  agents,
  campaignGroupId,
  campaignServiceId
) => {
  return apiCaller.post("/mini-crm/campaign", {
    name,
    note,
    callsPerAgent,
    startAt,
    endAt,
    agents,
    campaignGroupId,
    campaignServiceId,
  });
};
const editCampaignsApi = (
  id,
  isRunning,
  name,
  note,
  callsPerAgent,
  startAt,
  endAt,
  agents,
  campaignGroupId,
  campaignServiceId
) => {
  return apiCaller.put(`/mini-crm/campaign/${id}`, {
    isRunning,
    name,
    note,
    callsPerAgent,
    startAt,
    endAt,
    agents,
    campaignGroupId,
    campaignServiceId,
  });
};

const reloadCampaignsApi = (id, isDeleted) => {
  return apiCaller.put(`/mini-crm/campaign-allocation/${id}`, { isDeleted });
};

const deleteCampaignsApi = (id) => {
  return apiCaller.del(`/mini-crm/campaign/${id}`);
};

const campaignConfigApi = (
  campaignId,
  contactFileId,
  number,
  agentAllocationType,
  allowDuplicate,
  stages,
  formId,
  type,
  campaignIds,
  filterData,
  limit,
  agentId
) => {
  return apiCaller.post("/mini-crm/campaign-allocation", {
    campaignId,
    contactFileId,
    number,
    agentAllocationType,
    allowDuplicate,
    stages,
    formId,
    type,
    campaignIds,
    filterData,
    ...limit,
    ...agentId,
  });
};

const getCampaignAllocationApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/mini-crm/campaign-allocation", {
    order,
    limit,
    skip,
    ...where,
  });
};

const countListCampaignsAllocationApi = (where) => {
  return apiCaller.getData("/mini-crm/campaign-allocation/count", { ...where });
};

const getMoreDataApi = (campaignAllocationId, limit) => {
  return apiCaller.post("/mini-crm/campaign-allocation/get-more-data", {
    campaignAllocationId,
    limit,
  });
};

const getReasonSelectListApi = () => {
  return apiCaller.get("/mini-crm/reference-resource");
};

const getListCampaignsGroupApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/mini-crm/campaign-group", {
    order,
    limit,
    skip,
    ...where,
  });
};
const countListCampaignsGroupApi = (where) => {
  return apiCaller.getData("/mini-crm/campaign-group/count", { ...where });
};
const addNewCampaignsGroupApi = (name, code) => {
  return apiCaller.post("/mini-crm/campaign-group", { name, code });
};
const editCampaignsGroupApi = (id, name, code) => {
  return apiCaller.put(`/mini-crm/campaign-group/${id}`, { name, code });
};
const deleteCampaignsGroupApi = (id) => {
  return apiCaller.del(`/mini-crm/campaign-group/${id}`);
};

const getListCampaignsServiceApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/mini-crm/campaign-service", {
    order,
    limit,
    skip,
    ...where,
  });
};
const countListCampaignsServiceApi = (where) => {
  return apiCaller.getData("/mini-crm/campaign-service/count", { ...where });
};
const addNewCampaignsServiceApi = (name, code) => {
  return apiCaller.post("/mini-crm/campaign-service", { name, code });
};
const editCampaignsServiceApi = (id, name, code) => {
  return apiCaller.put(`/mini-crm/campaign-service/${id}`, { name, code });
};
const deleteCampaignsServiceApi = (id) => {
  return apiCaller.del(`/mini-crm/campaign-service/${id}`);
};

/**
 * sagas
 */

export const getListCampaignsFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_CAMPAIGNS);
    try {
      const res = yield call(
        getListCampaignsApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({ type: GET_LIST_CAMPAIGNS_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_LIST_CAMPAIGNS_ERROR, error });
    }
  }
};

export const checkCampaignGroupCodeFlow = function* () {
  while (true) {
    const action = yield take(CHECK_CAMPAIGN_GROUP_CODE);
    try {
      const res = yield call(checkCampaignGroupCodeApi, action.data.code);
      yield put({
        type: CHECK_CAMPAIGN_GROUP_CODE_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: CHECK_CAMPAIGN_GROUP_CODE_ERROR, error });
    }
  }
};

export const checkCampaignServiceCodeFlow = function* () {
  while (true) {
    const action = yield take(CHECK_CAMPAIGN_SERVICE_CODE);
    try {
      const res = yield call(checkCampaignServiceCodeApi, action.data.code);
      yield put({
        type: CHECK_CAMPAIGN_SERVICE_CODE_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: CHECK_CAMPAIGN_SERVICE_CODE_ERROR, error });
    }
  }
};

export const getAllCampaignsFlow = function* () {
  while (true) {
    yield take(GET_ALL_CAMPAIGNS);
    try {
      const res = yield call(getAllCampaignsApi);
      yield put({ type: GET_ALL_CAMPAIGNS_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_ALL_CAMPAIGNS_ERROR, error });
    }
  }
};

export const countCampaignsFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_CAMPAIGNS);
    try {
      const res = yield call(countListCampaignsApi, action.data.where);
      yield put({
        type: COUNT_LIST_CAMPAIGNS_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_CAMPAIGNS_ERROR, error });
    }
  }
};

export const addNewCampaignsFlow = function* () {
  while (true) {
    const action = yield take(ADD_NEW_CAMPAIGN);
    try {
      const res = yield call(
        addNewCampaignsApi,
        action.data.name,
        action.data.note,
        action.data.callsPerAgent,
        action.data.startAt,
        action.data.endAt,
        action.data.agents,
        action.data.campaignGroupId,
        action.data.campaignServiceId
      );
      yield put({ type: ADD_NEW_CAMPAIGN_SUCCESS, payload: { ...res.data } });
      const history = globalHistory();
      history.push(`${process.env.REACT_APP_PATH}/mini-crm/campaign`);
    } catch (error) {
      yield put({ type: ADD_NEW_CAMPAIGN_ERROR, error });
    }
  }
};

export const editCampaignsFlow = function* () {
  while (true) {
    const action = yield take(EDIT_A_CAMPAIGN);
    try {
      const res = yield call(
        editCampaignsApi,
        action.data.id,
        action.data.isRunning,
        action.data.name,
        action.data.note,
        action.data.callsPerAgent,
        action.data.startAt,
        action.data.endAt,
        action.data.agents,
        action.data.campaignGroupId,
        action.data.campaignServiceId
      );

      yield put({ type: EDIT_A_CAMPAIGN_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: EDIT_A_CAMPAIGN_ERROR, error });
    }
  }
};

export const reloadCampaignsFlow = function* () {
  while (true) {
    const action = yield take(RELOAD_CAMPAIGN);
    try {
      const res = yield call(
        reloadCampaignsApi,
        action.data.id,
        action.data.isDeleted
      );
      yield put({ type: RELOAD_CAMPAIGN_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: RELOAD_CAMPAIGN_ERROR, error });
    }
  }
};

export const deleteCampaignsFlow = function* () {
  while (true) {
    const action = yield take(DELETE_A_CAMPAIGN);
    try {
      const res = yield call(deleteCampaignsApi, action.data.id);
      yield put({ type: DELETE_A_CAMPAIGN_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: DELETE_A_CAMPAIGN_ERROR, error });
    }
  }
};

export const getACampaignDetailFow = function* () {
  while (true) {
    const action = yield take(GET_A_CAMPAIGN_DETAIL);
    const campaigns = yield select((state) => state.campaign);
    if (campaigns.length) {
      const _campaigns = campaigns.filter((c) => c.id == action.data.id);
      if (_campaigns.length == 1) {
        const campaign = _campaigns[0];
        yield put({ type: GET_A_CAMPAIGN_DETAIL_SUCCESS, payload: campaign });
        continue;
      }
    }
    try {
      const res = yield call(getListCampaignsApi);
      yield put({ type: GET_LIST_CAMPAIGNS_SUCCESS, payload: { ...res.data } });
      const _campaigns = res.data.filter((c) => c.id == action.data.id);
      if (_campaigns.length == 1) {
        const campaign = _campaigns[0];
        yield put({ type: GET_A_CAMPAIGN_DETAIL_SUCCESS, payload: campaign });
        continue;
      } else {
        throw new AppError(null, "Không tìm thấy bản ghi này");
      }
    } catch (error) {
      const history = globalHistory();
      history.replace(`${process.env.REACT_APP_PATH}/mini-crm/campaign`);
      yield put({ type: GET_A_CAMPAIGN_DETAIL_ERROR, error });
    }
  }
};

export const campaignConfigFlow = function* () {
  while (true) {
    const {
      data: {
        campaignId,
        contactFileId,
        number,
        agentAllocationType,
        allowDuplicate,
        stages,
        formId,
        type,
        campaignIds,
        filterData,
        limit,
        agentId,
      },
    } = yield take(CAMPAIGN_CONFIG);
    try {
      const res = yield call(
        campaignConfigApi,
        campaignId,
        contactFileId,
        number,
        agentAllocationType,
        allowDuplicate,
        stages,
        formId,
        type,
        campaignIds,
        filterData,
        limit,
        agentId
      );
      yield put({ type: CAMPAIGN_CONFIG_SUCCESS, payload: { ...res.data } });
      // const history = globalHistory();
      // history.push(`${process.env.REACT_APP_PATH}/mini-crm/campaign`);
    } catch (error) {
      yield put({ type: CAMPAIGN_CONFIG_ERROR, error });
    }
  }
};

export const getCampaignAllocationFlow = function* () {
  while (true) {
    const action = yield take(GET_CAMPAIGN_ALLOCATION);
    try {
      const res = yield call(
        getCampaignAllocationApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({
        type: GET_CAMPAIGN_ALLOCATION_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: GET_CAMPAIGN_ALLOCATION_ERROR, error });
    }
  }
};

export const countCampaignsAllocationFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_CAMPAIGNS_ALLOCATION);
    try {
      const res = yield call(
        countListCampaignsAllocationApi,
        action.data.where
      );
      yield put({
        type: COUNT_LIST_CAMPAIGNS_ALLOCATION_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_CAMPAIGNS_ALLOCATION_ERROR, error });
    }
  }
};

export const getMoreDataFlow = function* () {
  while (true) {
    const action = yield take(CAMPAIGN_ALLOCATION_GET_MORE_DATA);
    try {
      const res = yield call(
        getMoreDataApi,
        action.data.campaignAllocationId,
        action.data.limit
      );
      yield put({
        type: CAMPAIGN_ALLOCATION_GET_MORE_DATA_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: CAMPAIGN_ALLOCATION_GET_MORE_DATA_ERROR, error });
    }
  }
};

export const getReasonSelectFlow = function* () {
  while (true) {
    yield take(GET_REASON_SELECT_LIST);
    try {
      const res = yield call(getReasonSelectListApi);
      yield put({
        type: GET_REASON_SELECT_LIST_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      yield put({ type: GET_REASON_SELECT_LIST_ERROR, error });
    }
  }
};

export const getListCampaignsGroupFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_CAMPAIGNS_GROUP);
    try {
      const res = yield call(
        getListCampaignsGroupApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({
        type: GET_LIST_CAMPAIGNS_GROUP_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: GET_LIST_CAMPAIGNS_GROUP_ERROR, error });
    }
  }
};

export const countCampaignsGroupFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_CAMPAIGNS_GROUP);
    try {
      const res = yield call(countListCampaignsGroupApi, action.data.where);
      yield put({
        type: COUNT_LIST_CAMPAIGNS_GROUP_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_CAMPAIGNS_GROUP_ERROR, error });
    }
  }
};

export const addNewCampaignsGroupFlow = function* () {
  while (true) {
    const action = yield take(ADD_NEW_CAMPAIGN_GROUP);
    try {
      const res = yield call(
        addNewCampaignsGroupApi,
        action.data.name,
        action.data.code
      );
      yield put({
        type: ADD_NEW_CAMPAIGN_GROUP_SUCCESS,
        payload: { ...res.data },
      });
      const history = globalHistory();
      history.push(`${process.env.REACT_APP_PATH}/mini-crm/campaign-group`);
    } catch (error) {
      yield put({ type: ADD_NEW_CAMPAIGN_GROUP_ERROR, error });
    }
  }
};

export const editCampaignsGroupFlow = function* () {
  while (true) {
    const action = yield take(EDIT_A_CAMPAIGN_GROUP);
    try {
      const res = yield call(
        editCampaignsGroupApi,
        action.data.id,
        action.data.name,
        action.data.code
      );
      yield put({
        type: EDIT_A_CAMPAIGN_GROUP_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: EDIT_A_CAMPAIGN_GROUP_ERROR, error });
    }
  }
};

export const deleteCampaignsGroupFlow = function* () {
  while (true) {
    const action = yield take(DELETE_A_CAMPAIGN_GROUP);
    try {
      const res = yield call(deleteCampaignsGroupApi, action.data.id);
      yield put({
        type: DELETE_A_CAMPAIGN_GROUP_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: DELETE_A_CAMPAIGN_GROUP_ERROR, error });
    }
  }
};

export const getListCampaignsServiceFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_CAMPAIGNS_SERVICE);
    try {
      const res = yield call(
        getListCampaignsServiceApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({
        type: GET_LIST_CAMPAIGNS_SERVICE_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: GET_LIST_CAMPAIGNS_SERVICE_ERROR, error });
    }
  }
};

export const countCampaignsServiceFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_CAMPAIGNS_SERVICE);
    try {
      const res = yield call(countListCampaignsServiceApi, action.data.where);
      yield put({
        type: COUNT_LIST_CAMPAIGNS_SERVICE_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_CAMPAIGNS_SERVICE_ERROR, error });
    }
  }
};

export const addNewCampaignsServiceFlow = function* () {
  while (true) {
    const action = yield take(ADD_NEW_CAMPAIGN_SERVICE);
    try {
      const res = yield call(
        addNewCampaignsServiceApi,
        action.data.name,
        action.data.code
      );
      yield put({
        type: ADD_NEW_CAMPAIGN_SERVICE_SUCCESS,
        payload: { ...res.data },
      });
      const history = globalHistory();
      history.push(`${process.env.REACT_APP_PATH}/mini-crm/campaign-service`);
    } catch (error) {
      yield put({ type: ADD_NEW_CAMPAIGN_SERVICE_ERROR, error });
    }
  }
};

export const editCampaignsServiceFlow = function* () {
  while (true) {
    const action = yield take(EDIT_A_CAMPAIGN_SERVICE);
    try {
      const res = yield call(
        editCampaignsServiceApi,
        action.data.id,
        action.data.name,
        action.data.code
      );
      yield put({
        type: EDIT_A_CAMPAIGN_SERVICE_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: EDIT_A_CAMPAIGN_SERVICE_ERROR, error });
    }
  }
};

export const deleteCampaignsServiceFlow = function* () {
  while (true) {
    const action = yield take(DELETE_A_CAMPAIGN_SERVICE);
    try {
      const res = yield call(deleteCampaignsServiceApi, action.data.id);
      yield put({
        type: DELETE_A_CAMPAIGN_SERVICE_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: DELETE_A_CAMPAIGN_SERVICE_ERROR, error });
    }
  }
};
